var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.rowSpacing},[_c('CheckboxWithLabel',{attrs:{"disabled":_vm.alreadyHasPosixGroup,"label":"Create Linux group for this user group","tooltip":_vm.$options.tooltip,"value":_vm.hasPosixGroup},on:{"change":_vm.handlePosixGroupChange}}),_c('transition',{attrs:{"name":_vm.$style.groupInputs}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasPosixGroup),expression:"hasPosixGroup"}],class:_vm.$style.inputRow},[_c('InputValidator',{class:_vm.$style.half,attrs:{"config":{
          attribute: 'posixGroupName',
          label: 'Group Name',
          name: 'Posix Group Name',
          readonly: _vm.alreadyHasPosixGroup,
          scope: 'PosixGroup',
          validate: 'required|max:16|alpha_dash|firstCharIsNotDash|nameCannotBeGroupName',
          value: _vm.posixGroupName,
        }},on:{"InputValidatorModel":_vm.handlePosixInputChange}}),_c('InputValidator',{class:_vm.$style.half,attrs:{"config":{
          attribute: 'posixGroupId',
          label: 'Group GID',
          name: 'Posix Group GID',
          readonly: _vm.alreadyHasPosixGroup,
          scope: 'PosixGroup',
          validate: 'required|numeric',
          value: _vm.posixGroupId,
        }},on:{"InputValidatorModel":_vm.handlePosixInputChange}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }